/**
 * Pure helpers for the alerts badge — kept out of the component so the count /
 * label logic is unit-testable without rendering.
 */
import type { Alert } from '../api.js';

/** How many alerts still need attention (unacknowledged). */
export function unackedCount(alerts: Alert[]): number {
  return alerts.reduce((n, a) => (a.acknowledged ? n : n + 1), 0);
}

/** Badge label: '' when zero (badge hidden), capped at '9+'. */
export function badgeLabel(count: number): string {
  if (count <= 0) return '';
  return count > 9 ? '9+' : String(count);
}

/** A short human title for a rule id, for the dropdown list. */
export function ruleTitle(alert: Alert): string {
  const meta = alert.meta as { title?: unknown } | null;
  if (meta && typeof meta.title === 'string' && meta.title.trim()) return meta.title;
  return alert.ruleId;
}
